import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { TrackingProductData } from 'src/tracking/common/products';
import { RecommendationsServiceProduct } from '../../../services/recommendations';

export const mapProductToTrackingProduct = (
  {
    new: isNew,
    on_sale: onSale,
    sale_percentage: salePercentage,
    prices,
    free_domestic_delivery: freeDomesticDelivery,
    ...product
  }: RecommendationsServiceProduct,
  currency: CurrencyCode,
) =>
  ({
    isNew,
    onSale,
    salePercentage,
    freeDomesticDelivery,
    price: prices.find((prices) => prices.currency === currency),
    ...product,
  } as TrackingProductData);
